/**
 * 打字护栏：最后一次按键后这么久之内，下注按钮不响应按下。
 *
 * 轮到你时也能边打字边下注（键盘弹起，下注栏抬到输入框上方）。输入框夹在键盘和下注栏之间
 * 是结构上的隔离；这里是时间上的隔离 —— 人从打字切到下注不会快过 0.3 秒，
 * 快过这个的按下基本就是打字的手指蹭到了上面一排。
 *
 * 用模块级时间戳而不是 store：每个按键都写 store 会让整条 dock 重渲染（红线 #48 的同一类问题）。
 */
export const TYPING_GUARD_MS = 300

let lastKeyAt = Number.NEGATIVE_INFINITY

function now(): number {
  return typeof performance !== 'undefined' ? performance.now() : Date.now()
}

export function noteTyping(at: number = now()): void {
  lastKeyAt = at
}

export function typingGuardActive(at: number = now()): boolean {
  return at - lastKeyAt < TYPING_GUARD_MS
}

/** 仅供测试 */
export function __resetTypingGuard(): void {
  lastKeyAt = Number.NEGATIVE_INFINITY
}
